import React from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { useLocation } from "react-router-dom";
import {
  faBars,
  faBell,
  faChevronRight,
} from "@fortawesome/free-solid-svg-icons";
import IRouter from "../SideBar/interface";
import "./TopBar.css";

interface ITopBar {
  menuData: IRouter[];
  onToggleSidebar: () => void;
}

export default function TopBar({ menuData, onToggleSidebar }: ITopBar) {
  const location = useLocation();
  const segment = location.pathname.split("/")[2] || "";

  const current = menuData.find((m) => m.path === segment);
  const pageName = current?.name || "Dashboard";

  return (
    <header className="ds-topbar">
      <div className="ds-topbar-left">
        <button
          type="button"
          className="ds-icon-btn ds-topbar-toggle"
          onClick={onToggleSidebar}
          aria-label="Toggle sidebar"
        >
          <FontAwesomeIcon icon={faBars} />
        </button>

        <nav className="ds-breadcrumbs">
          <span className="ds-crumb ds-crumb--root">Superadmin</span>
          <FontAwesomeIcon icon={faChevronRight} className="ds-crumb-sep" />
          <span className="ds-crumb ds-crumb--current">{pageName}</span>
        </nav>
      </div>

      <div className="ds-topbar-right">
        {/* <button type="button" className="ds-icon-btn ds-hide-sm" aria-label="Notifications">
          <FontAwesomeIcon icon={faBell} />
          <span className="ds-bell-dot" />
        </button> */}

        <div className="ds-profile">
          <span className="ds-avatar ds-avatar--sm">SA</span>
          <div className="ds-profile-meta ds-hide-md">
            <span className="ds-profile-name">Super Admin</span>
            <span className="ds-profile-role">Administrator</span>
          </div>
        </div>
      </div>
    </header>
  );
}
